:host {
  display: block;
}
